:host {
  display: block;
}
